import React, { useState } from "react";
import { useNavigate, Outlet, useLocation } from "react-router-dom";
import ScrollToTop from "../components/ScrollToTop";

function Layout() {
	const navigate = useNavigate();
	const location = useLocation();
	const [isOpen, setIsOpen] = useState(false);

	const navItems = [
		{ name: "Home", path: "/" },
		{ name: "Leadership Skills", path: "/leadership-skills" },
		{ name: "Experience", path: "/experience-projects" },
		// { name: "Testimonials", path: "/testimonials" },
		{ name: "Personal Profile", path: "/about-me" },
	];

	const handleNav = (path) => {
		navigate(path);
		setIsOpen(false);
	};

	return (
		<div className="flex flex-col flex-1 bg-slate-50 min-h-0">
			<ScrollToTop />

			{/* Sticky top navbar */}
			<nav className="sticky top-0 z-50 bg-primary shadow-md">
				<div className="max-w-5xl mx-auto px-4 flex items-center justify-between h-14">
					{/* Brand */}
					<button
						onClick={() => handleNav("/")}
						className="text-white font-bold text-lg tracking-tight hover:text-accent transition-colors"
					>
						Daniel Middleton
					</button>

					{/* Desktop links */}
					<div className="hidden md:flex items-center space-x-1">
						{navItems.map((item) => {
							const isActive = location.pathname === item.path;
							return (
								<button
									key={item.path}
									onClick={() => handleNav(item.path)}
									className={`px-4 py-2 rounded text-sm font-medium transition-colors ${
										isActive
											? "bg-white/20 text-white"
											: "text-white/75 hover:text-white hover:bg-white/10"
									}`}
								>
									{item.name}
								</button>
							);
						})}
					</div>

					{/* Mobile hamburger */}
					<button
						onClick={() => setIsOpen(!isOpen)}
						className="md:hidden text-white text-2xl focus:outline-none leading-none"
						aria-label="Toggle menu"
					>
						{isOpen ? "✕" : "☰"}
					</button>
				</div>

				{/* Mobile dropdown */}
				{isOpen && (
					<div className="md:hidden bg-primary border-t border-white/10 px-4 pb-3 space-y-1">
						{navItems.map((item) => {
							const isActive = location.pathname === item.path;
							return (
								<button
									key={item.path}
									onClick={() => handleNav(item.path)}
									className={`block w-full text-left px-3 py-2 rounded text-sm font-medium transition-colors ${
										isActive
											? "bg-white/20 text-white"
											: "text-white/75 hover:text-white hover:bg-white/10"
									}`}
								>
									{item.name}
								</button>
							);
						})}
					</div>
				)}
			</nav>
			<div className="w-full mb-12 relative">
				<img
					src="/bannerBackground.png"
					alt="Banner"
					className={`w-full object-cover block ${location.pathname === "/" ? "h-48 md:h-80" : "h-24 md:h-36"}`}
					style={{ objectPosition: "center top" }}
				/>
				{/* Hero overlay — only shown on the home route */}
				{location.pathname === "/" && (
					<div className="absolute inset-0 flex flex-col items-center justify-center bg-black/40">
						<h1 className="text-white text-3xl md:text-5xl font-extrabold tracking-tight drop-shadow-lg">
							Daniel Middleton
						</h1>
						<p className="text-accent text-base md:text-xl font-medium mt-2 drop-shadow">
							Senior Learning Systems Engineer
						</p>
						<p className="text-white/80 text-sm md:text-base mt-3 max-w-lg text-center px-4 drop-shadow">
							Building learner-centered digital experiences at the intersection of education, design, and engineering.
						</p>
					</div>
				)}
			</div>
			<div className="w-full px-4">
				<main className="flex-1 min-h-0">
					<Outlet />
				</main>
			</div>
		</div>
	);
}

export default Layout;
